import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyTheme, readTheme } from "./lib/theme";
import "./styles.css";
import "./admin/admin.css";
import "./screens/learning.css";
import "./project/project.css";
import "./project/paket.css";
import "./project/work/work.css";
import "./project/stages.css";
import "./penyedia/penyedia.css";
import "./pbj/pbj.css";
import "./project/activity-docs.css";
import "./docreview/docreview.css";

applyTheme(readTheme());

async function boot() {
  // Dev-only fixture mode (?fixtures=1), for auditing screens without the API.
  // build.ts defines process.env.NODE_ENV, so a production build folds this
  // branch away and also swaps ./dev/fixtures for an empty stub: no fixture
  // data can ship in the production bundle.
  if (process.env.NODE_ENV !== "production") {
    const { installFixturesFromUrl } = await import("./dev/fixtures");
    installFixturesFromUrl();
  }
  const root = document.getElementById("root");
  if (!root) throw new Error("#root element not found");
  createRoot(root).render(<App />);
}

void boot();
